import { FunctionComponent } from "react";
import ReactDOMServer from "react-dom/server";
import { Quill } from "react-quill";

import { Bold, Italic, Link, ListBullets, ListNumbers } from "shared/assets/icons";
import { Icon } from "shared/styles";
import { Spacer } from "shared/layout";

import { StyledToolbar } from "../styles";
import { ToolbarButton } from "../components";

const getStringIcon = (icon: FunctionComponent<any>) =>
  ReactDOMServer.renderToString(<Icon as={icon} size="l" />);

const Icons = Quill.import("ui/icons");
Icons["bold"] = getStringIcon(Bold);
Icons["italic"] = getStringIcon(Italic);
Icons["link"] = getStringIcon(Link);
Icons["list"] = {
  unordered: getStringIcon(ListBullets),
  ordered: getStringIcon(ListNumbers),
};

export enum ToolbarItems {
  list,
  link,
}

export interface ToolbarProps {
  id: string;
  excludeItems?: { [key in ToolbarItems]?: boolean };
}

export const Toolbar = ({ id, excludeItems = {} }: ToolbarProps) => {
  return (
    <StyledToolbar id={id}>
      <Spacer spaceDirection="horizontal" size="l">
        <Spacer spaceDirection="horizontal" size="xs">
          <ToolbarButton className="ql-bold" />
          <ToolbarButton className="ql-italic" />
        </Spacer>
        {!excludeItems[ToolbarItems.list] && (
          <Spacer spaceDirection="horizontal" size="xs">
            <ToolbarButton className="ql-list" value="unordered" />
            <ToolbarButton className="ql-list" value="ordered" />
          </Spacer>
        )}
        {!excludeItems[ToolbarItems.link] && <ToolbarButton className="ql-link" />}
      </Spacer>
    </StyledToolbar>
  );
};
